module.exports = __webpack_public_path__ + "img/creditcards.9a7ca260.jpg";